<template>
  <a-drawer
    :visible="menuVisible"
    class="homeDrawer"
    placement="left"
    width="330"
    @close="cancel"
    destroyOnClose
  >
    <template v-for="index in numArr">
      <menu-ul :key="index" :list="list" :sort="index" :len="len" class="half" :max="max*(1+index)" :min="index*max" />
    </template>
    <div class="clear"></div>
  </a-drawer>
</template>
<script>
import { mapState,mapMutations } from 'vuex'
import MenuUl from './MenuUl.vue'
let len = 3
let max = 5

export default {
  props:['list'],
  components: {MenuUl},
  data(){
    return{
      // menuVisible: false
      len,
      max,
      numArr: Array.from({length:len},(v,i) => i)
    }
  },
  methods:{
    ...mapMutations('home',['setState']),
    cancel(){
      this.setState({menuVisible: false})
    }
  },
  computed:{
    ...mapState('home',['menuVisible'])
  },
}
</script>
<style lang="scss">
.homeDrawer{
  height: calc(100% - 64px);
  margin-top: 64px;
  .ant-drawer-body{
    margin-top: 20px;
  }
  // .ant-drawer-left, .ant-drawer-right{
  //   top: 80px;
  // }
  // .ant-drawer-mask{
  //   top: 80px;
  // }
  // .ant-drawer-content-wrapper{
  //   height: calc(100% - 80px);
  //   margin-top: 80px;
  // }
}
</style>
<style lang="scss" scoped>
.half{
  width: 50%;
  // display: inline-block;
  float: left;
  padding-right: 15px;
}
.clear{
  clear: both;
}
</style>
